/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React, { useState } from "react";
import { Instagram, Linkedin, Youtube } from "lucide-react";

import Button from "../elements/Button";
import BrandLogo from "../assets/images/logo194.png";

export default function Footer() {
  const [showPolicies, setShowPolicies] = useState(false);

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-6 py-10 max-w-6xl">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-16">
          {/* Brand + Tagline */}
          <div className="flex flex-col items-start sm:items-start">
            <img
              src={BrandLogo}
              alt="CFOBridge Logo"
              className="h-16 w-auto mb-3"
            />
            <p className="text-gray-500 text-base sm:text-sm md:text-xl font-medium leading-snug">
              India's First Curated Board Network
            </p>
          </div>

          {/* Office Info */}
          <div>
            <h2 className="text-base sm:text-lg md:text-xl font-semibold text-theme-blue mb-3">
              Office
            </h2>
            <p className="text-gray-500 text-sm sm:text-base">info@guvrn.com</p>
            <p className="text-gray-500 text-sm sm:text-base mt-2 sm:mt-3">
              AWFIS, 10th Floor, <br />
              R-city Mall, LBS Marg, <br />
              Ghatkopar West, Mumbai, 400086
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-base sm:text-lg md:text-xl font-semibold text-theme-blue mb-3">
              Quick Links
            </h2>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Button
                  href="/about-guvrn"
                  type="link"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                >
                  About guvrn
                </Button>
              </li>
              <li>
                <Button
                  href="/company-charter"
                  type="link"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                >
                  For Companies
                </Button>
              </li>
              <li>
                <Button
                  href="/charters"
                  type="link"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                >
                  For Independent Directors
                </Button>
              </li>
              <li>
                <Button
                  href="/contact-guvrn"
                  type="link"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                >
                  Contact Us
                </Button>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h2 className="text-base sm:text-lg md:text-xl font-semibold text-theme-blue mb-3">
              Social
            </h2>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-center gap-2">
                <Instagram className="w-5 h-5 text-gray-500" />
                <Button
                  href="https://www.instagram.com/guvrn_25/"
                  type="link"
                  target="_blank"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                  isExternal
                >
                  Instagram
                </Button>
              </li>
              <li className="flex items-center gap-2">
                <Linkedin className="w-5 h-5 text-gray-500" />
                <Button
                  href="https://www.linkedin.com/company/guvrn/?viewAsMember=true"
                  type="link"
                  target="_blank"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                  isExternal
                >
                  LinkedIn
                </Button>
              </li>
              <li className="flex items-center gap-2">
                <Youtube className="w-5 h-5 text-gray-500" />
                <Button
                  href="https://www.youtube.com/@Guvrn25"
                  type="link"
                  target="_blank"
                  className="text-gray-500 hover:text-theme-blue transition text-sm sm:text-base"
                  isExternal
                >
                  Youtube
                </Button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 mt-8 pt-4">
          <div className="relative flex flex-col sm:flex-row items-center justify-center gap-3 text-gray-400 text-xs sm:text-sm">

            <span>
              © {new Date().getFullYear()} guvrn — All rights reserved.
            </span>

            {/* Divider */}
            <span className="hidden sm:inline">|</span>

            {/* Privacy Dropdown */}
            <button
              type="button"
              onClick={() => setShowPolicies(!showPolicies)}
              className="flex items-center gap-1 text-gray-500 hover:text-theme-blue transition"
            >
              Privacy Policy
              <span className={`transition-transform ${showPolicies ? "rotate-180" : ""}`}>
                ▾
              </span>
            </button>

            {showPolicies && (
              <div className="absolute bottom-full mb-3 left-1/2 -translate-x-1/2 
                              bg-white border border-gray-200 rounded-lg shadow-md 
                              px-4 py-3 z-50 max-w-[90vw]">
                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-600">
                  
                  <a
                    href="https://guvrn.com/policies/Guvrn_Privacy_Notice.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-[#196f8d]"
                  >
                    Privacy Notice
                  </a>

                  <span className="hidden sm:inline text-gray-300">|</span>
                  
                  <a
                    href="https://guvrn.com/policies/Guvrn%20-%20Grievance%20Redressal%20Policy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-[#196f8d]"
                  >
                    Grievance Redressal
                  </a>

                  <span className="hidden sm:inline text-gray-300">|</span>

                  <a
                    href="https://guvrn.com/policies/Guvrn%20-%20Refund%20Policy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-[#196f8d]"
                  >
                    Refund Policy
                  </a>

                  <span className="hidden sm:inline text-gray-300">|</span>

                  <a
                    href="https://guvrn.com/policies/Guvrn-%20Terms%20of%20Use%20(for%20Companies%20and%20Directors).pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-[#196f8d]"
                  >
                    Terms (Companies & Directors)
                  </a>

                  <span className="hidden sm:inline text-gray-300">|</span>

                  <a
                    href="https://guvrn.com/policies/Guvrn%20-%20Terms%20of%20Use%20(for%20Service%20Providers).pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-[#196f8d]"
                  >
                    Terms (Service Providers)
                  </a>

                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </footer>
  );
}
